/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { WorkstreamAuditResponse } from '../models/WorkstreamAuditResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class WorkstreamAuditService {

    /**
     * Get Workstream Audit
     * @param onTimeTimeframe
     * @returns WorkstreamAuditResponse Successful Response
     * @throws ApiError
     */
    public static getWorkstreamAuditApiV1WorkstreamAuditGet(
        onTimeTimeframe?: (string | null),
    ): CancelablePromise<WorkstreamAuditResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workstream/audit',
            query: {
                'on_time_timeframe': onTimeTimeframe,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
